import { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { mesasService } from '../../services';
import './Mesas.css';

const statusColors = { livre: '#52C41A', ocupada: '#FF4D4F', reservada: '#FAAD14' };
const statusLabels = { livre: 'Livre', ocupada: 'Ocupada', reservada: 'Reservada' };

const BASE_URL = window.location.origin;

export default function Mesas() {
  const [mesas, setMesas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mesaQR, setMesaQR] = useState(null);

  const carregar = () => {
    mesasService.listar()
      .then(res => setMesas(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { carregar(); }, []);

  const handleStatus = async (id, status) => {
    try {
      await mesasService.atualizarStatus(id, status);
      carregar();
    } catch (err) {
      alert(err.response?.data?.error || 'Erro ao atualizar mesa');
    }
  };

  if (loading) return <div className="loading"><div className="spinner"></div>Carregando...</div>;

  return (
    <div className="mesas-page">
      <h1>🪑 Mesas</h1>
      <div className="mesas-resumo">
        <span className="resumo-item"><span className="dot" style={{background:'#52C41A'}}></span> Livres: {mesas.filter(m => m.status === 'livre').length}</span>
        <span className="resumo-item"><span className="dot" style={{background:'#FF4D4F'}}></span> Ocupadas: {mesas.filter(m => m.status === 'ocupada').length}</span>
        <span className="resumo-item"><span className="dot" style={{background:'#FAAD14'}}></span> Reservadas: {mesas.filter(m => m.status === 'reservada').length}</span>
      </div>

      <div className="mesas-grid">
        {mesas.map(m => (
          <div key={m.id} className={`mesa-card mesa-${m.status}`}>
            <div className="mesa-numero">Mesa {m.numero}</div>
            <div className="mesa-status" style={{color: statusColors[m.status]}}>{statusLabels[m.status]}</div>
            <div className="mesa-info">
              <small>Capacidade: {m.capacidade} pessoas</small>
              {m.comandas_abertas > 0 && <small>📝 {m.comandas_abertas} comanda(s)</small>}
              {parseFloat(m.total_consumo) > 0 && <small>💰 R$ {parseFloat(m.total_consumo).toFixed(2)}</small>}
            </div>
            <div className="mesa-acoes">
              {m.status === 'livre' && <button className="btn btn-sm btn-danger" onClick={() => handleStatus(m.id, 'ocupada')}>Ocupar</button>}
              {m.status === 'livre' && <button className="btn btn-sm btn-warning" onClick={() => handleStatus(m.id, 'reservada')}>Reservar</button>}
              {m.status !== 'livre' && <button className="btn btn-sm btn-success" onClick={() => handleStatus(m.id, 'livre')}>Liberar</button>}
              <button className="btn btn-sm btn-info" onClick={() => setMesaQR(m)}>QR Code</button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal QR Code */}
      {mesaQR && (
        <div className="qr-overlay" onClick={() => setMesaQR(null)}>
          <div className="qr-modal" onClick={e => e.stopPropagation()}>
            <h2>QR Code — Mesa {mesaQR.numero}</h2>
            <div className="qr-box">
              <QRCodeSVG
                value={`${BASE_URL}/mesa/${mesaQR.numero}`}
                size={220}
                level="M"
                includeMargin={true}
              />
            </div>
            <p className="qr-url">{BASE_URL}/mesa/{mesaQR.numero}</p>
            <p className="qr-info">Cliente escaneia e faz pedido direto pelo celular</p>
            <button className="btn btn-primary" onClick={() => window.print()}>🖨 Imprimir</button>
            <button className="btn btn-outline" style={{marginLeft: 8}} onClick={() => setMesaQR(null)}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
}
